import React, { createContext, useContext, useState, useEffect } from 'react';
import api from './api';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(() => {
        try { return JSON.parse(localStorage.getItem('dg_admin_user') || 'null'); } catch { return null; }
    });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const token = localStorage.getItem('dg_admin_token');
        if (token && !user) {
            api.get('/auth/admin/me').then(r => {
                setUser(r.data);
                localStorage.setItem('dg_admin_user', JSON.stringify(r.data));
            }).catch(() => {
                localStorage.removeItem('dg_admin_token');
                localStorage.removeItem('dg_admin_user');
            });
        }
    }, []);

    const login = async (email, password) => {
        setLoading(true);
        try {
            const { data } = await api.post('/auth/admin/login', { email, password });
            localStorage.setItem('dg_admin_token', data.token);
            localStorage.setItem('dg_admin_user', JSON.stringify(data.user));
            setUser(data.user);
            return data.user;
        } finally {
            setLoading(false);
        }
    };

    const logout = () => {
        localStorage.removeItem('dg_admin_token');
        localStorage.removeItem('dg_admin_user');
        setUser(null);
        window.location.href = '/dharmikdashboard/login';
    };

    const hasRole = (...roles) => user && roles.includes(user.role);
    const isSuperAdmin = () => user?.role === 'super_admin';

    return (
        <AuthCtx.Provider value={{ user, loading, login, logout, hasRole, isSuperAdmin }}>
            {children}
        </AuthCtx.Provider>
    );
}

export function useAuth() {
    return useContext(AuthCtx);
}
